<template>
    <span>
        <button type="button"
                @click="showMenuUser = true"
                class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
            <span class="btn-icon-wrapper">
                <i class="fa fa-ellipsis-v fa-w-6"></i>
            </span>
        </button>
        <div :class="{'display-none':!showMenuUser}" class="bg-white-transparent fade show h-100 w-full" style="position: absolute; left: 0; top:0">
          <t-app-user-submenu  @closeSubmenu="closeSubmenu" mobile :user="user"/>
        </div>

    </span>
</template>

<script>
import TAppUserSubmenu from "@/components/template/header/t-app-user-submenu";
import ui from "@/assets/scripts/ui";

export default {
  name: "t-app-menu-right-button-mobile",
  components: {TAppUserSubmenu},
  data() {
    return {
      showMenuUser: false,

    }
  },
  methods: {
    closeSubmenu(){
      this.showMenuUser = false
    },
    exit() {
      ui.logout(this)
    },
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>